import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Usb"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 11.25V10.5H19.5V12H19.2993C19.04 11.5516 18.5552 11.25 18 11.25ZM17.25 12H19.2993C19.427 12.2206 19.5 12.4768 19.5 12.75V21H18V12.75H6V21H4.5V12.75C4.5 11.9216 5.17157 11.25 6 11.25V4.5C6 3.67157 6.67157 3 7.5 3H16.5C17.3284 3 18 3.67157 18 4.5V10.5H17.25V12ZM15.75 10.5H13.5V11.25H7.5V4.5H16.5V11.25H15.75V10.5ZM15.75 11.25V12H13.5V11.25H15.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Usb.vue"]]);
